export interface LegacyFormSubmissionDto {
    id: number;
    formName: string;
    date: string | null;
    pmsId: string | null;
    status: string;
}

export enum PatientInviteMethod {
    Email = 0,
    QrCode = 1,
    SMS = 2,
    SignInAs = 3
}

export enum PatientStatus {
    Fail = 0,
    Succeed = 1,
    PreviouslyCreated = 2
}

export interface FormAssignmentDto {
    id?: string;
    patientIndex?: number;
    formName?: string | undefined;
    formId?: string;
    formType?: string | undefined;
    assigned?: Date;
    assignedString?: string | undefined;
    submitted?: Date | undefined;
    submissionId?: string | undefined;
    submittedString?: string | undefined;
    rwPatientId?: number | undefined;
    order?: number;
    appointmentId?: number | undefined;
    dueDate?: Date | undefined;
}

export interface AddressDto {
    address1?: string | undefined;
    address2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
}

export interface LocationDto {
    id?: number;
    name?: string | undefined;
    address?: AddressDto | undefined;
}

export interface PatientDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cellPhone?: string | undefined;
    homePhone?: string | undefined;
    workPhone?: string | undefined;
    email?: string | undefined;
    dateOfBirth?: string | undefined;
    gender?: string | undefined;
    isResponsibleParty?: boolean;
    foreignId?: string | undefined;
    networkId?: number | undefined;
    address?: AddressDto | undefined;
    location?: LocationDto | undefined;
    needsConsent?: boolean;
    consentGiven?: boolean;
    consentGivenDisplay?: string | null;
    lastInvited?: Date | undefined;
    lastInvitedString?: string | undefined;
    formAssignments?: FormAssignmentDto[] | undefined;
}

export interface Invite {
    token: string | undefined;
}

export interface Cancel {
    message: string;
}

export interface CancelToken {
    promise: Promise<Cancel>;
    reason?: Cancel;
    throwIfRequested(): void;
}

export interface GetPatientResponse {
    isResponsibleParty?: boolean;
    responsiblePartyToDirectTo?: string | null;
    patients: PatientDto[];
}

export interface UserInfo {
    userId?: number | undefined;
    pin?: number;
}

export type FormAssignmentsIndexResponse = {
    specialties: SpecialtyIndexes[];
};

export type SpecialtyIndexes = {
    key: number;
    value: string;
};

export enum FormType {
    Registration = 0,
    Consent = 2,
    Miscellaneous = 3,
    Uploaded = 4
}

export enum Specialty {
    Anesthesia = 0,
    Cosmetic = 1,
    Dermatology = 2,
    EarNoseThroat = 3,
    Endo = 4,
    GD = 5,
    NonSpecialty = 6,
    OMS = 7,
    Ophthalmology = 8,
    Orthodontics = 9,
    Orthopedics = 10,
    Other = 11,
    Pediatric = 12,
    Periodontics = 13,
    PlasticSurgery = 14,
    Podiatry = 15,
    Prosthodontics = 16,
    Radiology = 17,
    Sedation = 18
}

export enum FormListType {
    All = 0,
    Custom = 1,
    Imported = 2
}

export enum ClientApp {
    Practice = 0,
    Patient = 1
}

export type Form = {
    index: number;
    id: string;
    name: string;
    formType: number;
    formTypeName: string;
    specialty: string;
    lastModified: string; // ISO 8601 date string
    lastModifiedBy: string;
    lastModifiedString: string; // Formatted date string
    locationIds: number[];
    autoSync: boolean;
};

export type FormListResponse = {
    count: number;
    forms: Form[];
};

export interface PacketForms {
    formId?: string;
    formName?: string | undefined;
    order?: number;
    formIndex?: number;
}

export type PacketListResponse = {
    count: number;
    packets: Packet[];
};

export type Packet = {
    id: string;
    name: string;
    created: Date;
    formCount: number;
    locationIds: number[];
    lastModifiedBy: string;
    lastModifiedString: string;
    lastModified: Date;
    formNames: string;
    isPublic: boolean;
};
